<app-chart-wrapper [isLoading]="isLoading" [title]="'Disbursed Loans'" i18n-title="@@disbursed_loans" (fullscreen)="hideFilters = $event">
    <!-- Filters -->
    <form filter [formGroup]="form" class="flex gap-1 mb-4" [ngClass]="showSortControl?'justify-between':'justify-end'">

        <ng-container *ngIf="showSortControl">
            <button mat-button [matMenuTriggerFor]="sorting" class="sort-btn">
                {{ sortLabel }}
                <img class="ml-2.5 h-5" src="assets/icons/sort-order.svg" alt="" />
              </button>
            <mat-menu #sorting="matMenu">
                <button mat-menu-item *ngFor="let option of sortOptions" (click)="onSort(option)">
                  {{ option.label }}
                </button>
            </mat-menu>
        </ng-container>

        <app-loan-product-search-select [disabled]="hideFilters" class="w-[40%] bg-white" (emitSelectedVal)="filterDisbursedLoansCount({ type: reportsInput.LOAN_PRODUCT, value: $event?.id })" [control]="productCtrl" type="client">
        </app-loan-product-search-select>


    </form>
    <!-- End Filters -->
    <app-circle-chart chart *ngIf="disbursedLoanCountChartData?.length === 1 && !isLoading" [width]="'50px'" [height]="'50px'" [totalAmount]="disbursedLoanCountChartData[0]?.value ?? 0" [imageName]="'hand_money'" [classNames]="'text-primary'" [type]="'number'">
    </app-circle-chart>
    <app-no-data-to-show chart *ngIf="!disbursedLoanCountChartData?.length && !isLoading"></app-no-data-to-show>

    <!-- <app-doughnut-chart chart *ngIf="numberOfTenantBranches > 1 && numberOfTenantBranches < 5"
        [chartData]="disbursedLoanCountChartData"
        [palette]="disbursedLoanCountPalette"
        [hasCurrencySymbol]="false"

    ></app-doughnut-chart> -->

    <app-column-chart chart *ngIf="disbursedLoanCountChartData?.length > 1 && !isLoading" barLabel="Count" [chartData]="disbursedLoanCountChartData" [sortingOptions]="disbursedLoanCountSortingOptions" [hasCurrencySymbol]="false">
    </app-column-chart>
</app-chart-wrapper>
